export class QuestionTableConstant{
    QEUSTION_RESPONSE_SUBMIT_SUCCESS:string = 'Response submitted successfully!';
    QEUSTION_RESPONSE_SUBMIT_ERROR:string = 'Error occured while saving question(s) response: ';

    GET_QUESTION_TABLE_DATA_API_ERROR: string = 'Error in getCategoryDropDown call/API: ';
    GET_RESPONSE_DROPDOWN_API_ERROR: string = 'Error in getQuestions call/API: ';
    GET_CATEGORY_DROPDOWN_API_ERROR: string = 'Error in getCategoryDropDown call/API: ';
    GET_CATEGORY_REVIEWER_API_ERROR: string = 'Error in getCategoryReviewer call/API: ';
    GET_QUESTION_RESPONSE_API_ERROR: string = 'Error in getQuestionResponse call/API: ';
    
    CATEGORY_REVIEW_SUBMIT_SUCCESS: string = 'Category review submitted successfully';
    CATEGORY_REVIEW_SUBMIT_ERROR:string = 'Error occured while saving review: ';
}